<template>
	<div>
		<v-dialog v-model="model" :class="$vuetify.breakpoint.xs ? 'mobile-dialog' : 'mt-10'"
			:max-width="$vuetify.breakpoint.xs ? '' : '1000'" :fullscreen="$vuetify.breakpoint.xs"
			:hide-overlay="$vuetify.breakpoint.xs" transition="dialog-bottom-transition">
			<v-card :class="$vuetify.breakpoint.xs ? 'mobile-card' : 'rounded-lg'"
				:style="$vuetify.breakpoint.xs ? 'max-width: 100vw; height: 100vh; overflow-y: auto; border: none !important; box-shadow: none !important; position: relative;' : 'max-width: 100%; overflow: hidden; border: none !important; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important; position: relative;'">
				<!-- Versión móvil -->
				<div v-if="$vuetify.breakpoint.xs" class="mobile-layout">
					<!-- Header móvil -->
					<div class="mobile-header pa-4">
						<v-icon class="close-icon-mobile" @click="closeDialog">mdi-close</v-icon>
						<div class="text-center">
							<div style="font-size: 20px" class="tit mb-2">
								<span style="background: linear-gradient(90deg, #4dd453, #4fee57);"
									class="rounded px-2">
									<span class="white--text mr-1 font-weight-bold">SeleAI <span
											style="color: rgb(59 59 59);">Premium</span></span>
								</span>
							</div>
							<div style="font-size: 13px !important; color: #616161;" class="text-center">
								<span>Mayor productividad. Más poder. Desbloquea todo el potencial de tu
									aprendizaje.</span>
							</div>
						</div>
					</div>

					<!-- Características móvil -->
					<div class="mobile-features pa-4">
						<div class="d-flex flex-column">
							<span style="font-size: 14px" class="font-weight-medium mb-3">Esto es lo que obtendrás con
								SeleAI <strong>PREMIUM</strong>:</span>

							<div class="d-flex align-start mb-3" style="font-size: 13px">
								<svg style="width: 18px; height: 18px; min-width: 18px;"
									xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
									fill="none" stroke="#4dd453" stroke-width="2" stroke-linecap="round"
									stroke-linejoin="round" class="lucide mr-2 lucide-brain-icon lucide-brain">
									<path
										d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" />
									<path
										d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" />
									<path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4" />
									<path d="M17.599 6.5a3 3 0 0 0 .399-1.375" />
									<path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" />
									<path d="M3.477 10.896a4 4 0 0 1 .585-.396" />
									<path d="M19.938 10.5a4 4 0 0 1 .585.396" />
									<path d="M6 18a4 4 0 0 1-1.967-.516" />
									<path d="M19.967 17.484A4 4 0 0 1 18 18" />
								</svg>
								<span><strong>Chat IA</strong> con tus documentos y asistente académico
									especializado</span>
							</div>
							<div style="font-size: 13px" class="d-flex align-start mb-3">
								<FileText :size="18" color="#4dd453" class="mr-2" style="min-width: 18px;" />
								<span><strong>Generación ilimitada</strong> de cuestionarios, resúmenes y tarjetas de
									estudio</span>
							</div>
							<div class="d-flex align-start mb-3">
								<UserX :size="18" color="#4dd453" class="mr-2" style="min-width: 18px;" />
								<span style="font-size: 13px"><strong>Modo anónimo</strong> para tus documentos
									personales</span>
							</div>
							<div class="d-flex align-start mb-3">
								<BookOpen :size="18" color="#4dd453" class="mr-2" style="min-width: 18px;" />
								<span style="font-size: 13px"><strong>Recursos premium</strong> y contenido inteligente
									de la comunidad</span>
							</div>
							<div class="d-flex align-start">
								<Download :size="18" color="#4dd453" class="mr-2" style="min-width: 18px;" />
								<span style="font-size: 13px"><strong>Descarga</strong> de todo el material</span>
							</div>
						</div>
					</div>

					<!-- Planes móvil -->
					<div class="mobile-plans pa-4">
						<!-- Banner promocional destacado -->
						<v-alert v-if="showDiscount" color="#4EEA57" class="promo-banner mb-4"
							style="border-radius: 12px; border: none; background-color: #f0ffec; font-size: 13px;"
							icon="mdi-ticket-percent">
							<div class="d-flex flex-column">
								<div class="font-rubik font-weight-bold mb-1">
									¡OFERTA LIMITADA! {{ countdownText }}
								</div>
								<div class="font-rubik">
									Obtén hasta un <strong>40% de descuento</strong> en cualquier plan Premium.
								</div>
							</div>
						</v-alert>

						<span style="font-size: 16px; color: #616161; line-height: 1.7;"
							class="mb-4 font-weight-bold font-rubik d-block">
							Elige tu plan
						</span>

						<div class="mobile-plan-cards font-rubik">
							<div class="mobile-plan-option mb-3" :class="{ 'active-plan': radioGroup === 1 }"
								@click="radioGroup = 1">
								<div class="d-flex justify-between mb-2">
									<div class="text-subtitle-1 font-weight-bold">PLAN 7 DÍAS</div>
								</div>
								<div class="mobile-price-amount font-rubik">
									<span v-if="showDiscount"
										class="font-weight-regular text-decoration-line-through mr-2"
										style="font-size: 16px; color: #888;">€4,99</span>
									<span :style="showDiscount ? 'color: #178038;' : ''">€{{ showDiscount ? '2,99' :
										'4,99' }}</span>
									<!-- <span class="mobile-price-period">/semana</span> -->
								</div>
								<div class="mobile-price-details font-rubik">por semana</div>
							</div>

							<div class="mobile-plan-option mb-3" :class="{ 'active-plan': radioGroup === 2 }"
								@click="radioGroup = 2">
								<div class="d-flex justify-between mb-2">
									<div class="text-subtitle-1 font-weight-bold">PLAN 1 MES</div>
								</div>
								<div class="mobile-price-amount font-rubik">
									<span v-if="showDiscount"
										class="font-weight-regular text-decoration-line-through mr-2"
										style="font-size: 16px; color: #888;">€8,99</span>
									<span :style="showDiscount ? 'color: #178038;' : ''">€{{ showDiscount ? '6,99' :
										'8,99' }}</span>
									<!-- <span class="mobile-price-period">/mes</span> -->
								</div>
								<div class="mobile-price-details font-rubik">por mes</div>
							</div>

							<!-- 
						<div class="mobile-plan-option" :class="{ 'active-plan': radioGroup === 3 }" @click="radioGroup = 3"
							style="position: relative;"
						>
							<div class="d-flex justify-between mb-2">
								<div class="text-subtitle-1 font-weight-bold">Premium Pago Único</div>
								<div 
									style="position: absolute; right: 8px; top: 8px;"
									class="discount-label-mobile" v-if="showDiscount">AHORRA 20%</div>
							</div>
							<span class="font-weight-regular text-decoration-line-through mr-2" style="font-size: 16px; color: #888;">
								€{{ showDiscount ? '14,99' : '29.99' }}
							</span>
							<div class="mobile-price-amount font-rubik" :style="showDiscount ? 'color: #ff5252;' : ''">€{{ showDiscount ? '9.99' : '14,99' }}<span class="mobile-price-period"></span></div>
							<div class="mobile-price-details font-rubik">pago único (duración <b>3 meses</b>)</div>
						</div>
						-->
						</div>
					</div>

					<!-- Botón y footer móvil -->
					<div class="mobile-footer pa-4">


						<div class="text-center px-12 py-4 mt-2 v-card v-card--flat v-sheet theme--light">
							<div
							style="font-size: 12px; background-color: rgb(213 255 228); border-radius: 6px; padding: 4px 8px; width: fit-content; margin: 0 auto;"
							class="mb-2 d-flex align-center text-center justify-center">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#178038" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-check-icon lucide-shield-check"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>
								
								<span style="font-size: 13px; color: #178038;" class="ml-1"> Paga Seguro y Protegido. </span>
							</div>
								<img height="32" src="https://examenselectivitat.cat:3000/api/images/other/available-payments.webp" style="object-fit: contain;">
						</div>

						<v-btn class="text-none shop-btn mobile-shop-btn" height="48" block @click="goToStripe"
							:disabled="!radioGroup" depressed>
							Comenzar Ahora
							<v-icon class="ml-2">mdi-arrow-right</v-icon>
						</v-btn>

						<div class="text-center mt-3 limited-offer-text">
							<small><v-icon x-small class="mr-1">mdi-clock</v-icon> Oferta limitada: {{ countdownText
								}}</small>
						</div>

						<div class="mt-4 text-center" style="font-size: 12px !important; color: #616161;">
							<span class="font-weight-medium">Cancela en cualquier momento.</span>
							<span> Los precios incluyen IVA.</span>
						</div>
					</div>
				</div>

				<!-- Versión desktop (original) -->
				<v-row v-else no-gutters dense style="height: 100% !important; min-height: 480px">
					<v-col cols="12" md="5" class="pa-9 my-1" style="height: 100%">
						<div style="font-size: 24px" class="tit mb-2">
							<span style="background: linear-gradient(90deg, #4dd453, #4fee57);" class="rounded px-2">
								<span class="white--text mr-1 font-weight-bold">SeleAI <span
										style="color: rgb(59 59 59);">Premium</span></span>

							</span>
						</div>

						<!-- Alerta promocional -->
						<v-alert v-if="false" dense color="success" text class="my-3 promo-alert"
							style="border-left: 4px solid #4dd453;">
							<div class="d-flex align-center">
								<v-icon color="#4dd453" small class="mr-2">mdi-tag</v-icon>
								<span>
									<strong>¡OFERTA ESPECIAL!</strong> 20% de descuento para los primeros 20 clientes
									con el código <strong>sele-20</strong> para siempre
								</span>
							</div>
							<div class="mt-1">
								<small>¡Ya aplicado automáticamente en tu compra!</small>
							</div>
						</v-alert>

						<div style="font-size: 14px !important; color: #616161;">
							<span>Mayor productividad. Más poder. Desbloquea todo el potencial de tu aprendizaje.</span>
						</div>

						<div class="d-flex flex-column mt-6">
							<span style="font-size: 15px" class="font-weight-medium">Esto es lo que obtendrás con SeleAI
								<strong>PREMIUM</strong>.</span>
							<span class="pb-3"></span>
							<div class="d-flex align-start mb-4" style="font-size: 14px">
								<svg style="width: 20px; height: 20px;" xmlns="http://www.w3.org/2000/svg" width="24"
									height="24" viewBox="0 0 24 24" fill="none" stroke="#4dd453" stroke-width="2"
									stroke-linecap="round" stroke-linejoin="round"
									class="lucide mr-2 lucide-brain-icon lucide-brain">
									<path
										d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" />
									<path
										d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" />
									<path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4" />
									<path d="M17.599 6.5a3 3 0 0 0 .399-1.375" />
									<path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" />
									<path d="M3.477 10.896a4 4 0 0 1 .585-.396" />
									<path d="M19.938 10.5a4 4 0 0 1 .585.396" />
									<path d="M6 18a4 4 0 0 1-1.967-.516" />
									<path d="M19.967 17.484A4 4 0 0 1 18 18" />
								</svg>
								<span>
									<strong>Chat IA</strong>
									con tus documentos y asistente académico especializado
								</span>
							</div>
							<div style="font-size: 14px" class="d-flex align-start mb-4">
								<FileText :size="20" color="#4dd453" class="mr-2" />
								<span>
									<strong>Generación ilimitada</strong>
									de cuestionarios, resúmenes y tarjetas de estudio
								</span>
							</div>
							<div class="d-flex align-start mb-4">
								<UserX :size="20" color="#4dd453" class="mr-2" />
								<span style="font-size: 14px">
									<strong>Modo anónimo</strong>
									para tus documentos personales
								</span>
							</div>
							<div class="d-flex align-start mb-4">
								<BookOpen :size="20" color="#4dd453" class="mr-2" />
								<span style="font-size: 14px">
									<strong>Recursos premium</strong>
									y contenido inteligente de la comunidad
								</span>
							</div>
							<div class="d-flex align-start">
								<Download :size="20" color="#4dd453" class="mr-2" />
								<span style="font-size: 14px">
									<strong>Descarga</strong>
									de todo el material
								</span>
							</div>
						</div>

						<div class="mt-6" style="font-size: 14px !important; color: #616161;">
							<span class="font-weight-medium">Cancela en cualquier momento.</span>
							<span> Los precios son precios fijados e incluyen IVA.</span>
						</div>

					</v-col>
					<v-col cols="12" md="7" class="d-flex flex-column pa-4" style="background-color: #f8f9fa;">
						<div class="pa-4 d-flex flex-column justify-center" style="height: 100%;">

							<span style="font-size: 18px; color: #616161; line-height: 1.7;"
								class="mb-6 font-weight-bold font-rubik">
								Elige tu plan
							</span>

							<!-- Banner promocional destacado -->
							<v-alert v-if="showDiscount" color="#4EEA57" class="promo-banner mb-4"
								style="border-radius: 12px; border: none; background-color: #f0ffec;"
								icon="mdi-ticket-percent">
								<div class="d-flex flex-column">
									<div class="font-rubik font-weight-bold mb-1">
										¡OFERTA LIMITADA! {{ countdownText }}
									</div>
									<div class=font-rubik>
										Obtén hasta un <strong>40% de descuento</strong> en cualquier plan Premium.
									</div>
								</div>
							</v-alert>

							<div class="plan-cards mt-4 font-rubik" style="gap: 16px;">
								<div class="plan-option" :class="{ 'active-plan': radioGroup === 1 }"
									@click="radioGroup = 1">
									<div class="d-flex justify-between">
										<div class="font-weight-bold">PLAN 7 DÍAS</div>
									</div>
									<div class="price-amount font-rubik">
										<span v-if="showDiscount"
											class="font-weight-regular text-decoration-line-through mr-2"
											style="font-size: 18px; color: #888;">€4,99</span>
										<span style="font-size: 22px;"
											:style="showDiscount ? 'color: #178038;' : ''">€{{ showDiscount ? '2,99' :
											'4,99' }}</span>
										<!-- <span class="price-period">/semana</span> -->
									</div>
									<div class="price-details font-rubik">por semana</div>

								</div>
								<div class="plan-option" :class="{ 'active-plan': radioGroup === 2 }"
									@click="radioGroup = 2">
									<div class="d-flex justify-between">
										<div class="font-weight-bold">PLAN 1 MES</div>
									</div>
									<div class="price-amount font-rubik">
										<span v-if="showDiscount"
											class="font-weight-regular text-decoration-line-through mr-2"
											style="font-size: 18px; color: #888;">€8,99</span>
										<span style="font-size: 22px;"
											:style="showDiscount ? 'color: #178038;' : ''">€{{ showDiscount ? '6,99' :
											'8,99' }}</span>
										<!-- <span class="price-period">/mes</span> -->
									</div>
									<div class="price-details font-rubik">por mes</div>
								</div>
								<!-- 
								<div class="plan-option" :class="{ 'active-plan': radioGroup === 3 }" @click="radioGroup = 3"
								style="position: relative; z-index: 2;"
								>
									<div class="d-flex justify-between mb-3">
										<div class="text-h6 font-weight-bold">Premium Pago Único</div>
										<div 
										style="position: absolute; right: 0; top: 0;"
										class="discount-label" v-if="showDiscount">AHORRA 20%</div>
									</div>
									<span class="font-weight-regular text-decoration-line-through mr-2" style="font-size: 18px; color: #888;">
										€{{ showDiscount ? '14,99' : '29.99' }}
									</span>
									<div class="price-amount font-rubik" :style="showDiscount ? 'color: #ff5252;' : ''">€{{ showDiscount ? '9.99' : '14,99' }}<span class="price-period"></span></div>
									<div class="price-details font-rubik">pago único (duración <b>3 meses</b>)</div>
									
								</div>
								-->
							</div>



						<div class="text-center px-12 mt-6 py-1">
							<div
							style="font-size: 12px; background-color: rgb(213 255 228); border-radius: 6px; padding: 4px 8px; width: fit-content; margin: 0 auto;"
							class="mb-2 d-flex align-center text-center justify-center">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#178038" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-check-icon lucide-shield-check"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>
								
								<span style="font-size: 13px; color: #178038;" class="ml-1"> Paga Seguro y Protegido. </span>
							</div>
								<img height="32" src="https://examenselectivitat.cat:3000/api/images/other/available-payments.webp" style="object-fit: contain;">
						</div>


							<v-card-actions class="pa-0">

								
								<v-btn class="text-none shop-btn" height="48" style="flex: 1; font-size: 16px;"
									@click="goToStripe" :disabled="!radioGroup" depressed>
									Comenzar Ahora
									<v-icon class="ml-2">mdi-arrow-right</v-icon>
								</v-btn>
							</v-card-actions>

							<div class="text-center mt-3 limited-offer-text">
								<small><v-icon x-small class="mr-1">mdi-clock</v-icon> Oferta limitada: {{ countdownText
									}}</small>
							</div>

						</div>
					</v-col>
				</v-row>

				<v-icon v-if="!$vuetify.breakpoint.xs" class="close-icon" @click="closeDialog">mdi-close</v-icon>


			</v-card>

			<!-- Dialog para login -->
			<v-dialog v-model="showLoginDialog" content-class="rounded-xl" persistent max-width="450">
				<div style="position: relative">
					<login-card :dialog.sync="showLoginDialog" :subtitle="'Inicia sesión para continuar'"
						:redirect="$route.path"></login-card>
				</div>
			</v-dialog>


		</v-dialog>
	</div>
</template>

<script>
import {
	Brain,
	FileText,
	Star,
	Copy,
	ChevronLeft,
	Check,
	UserX,
	BookOpen,
	Download,
} from 'lucide-vue'
import { loadStripe } from "@stripe/stripe-js";
import LoginCard from "@/views/profile/login/components/LoginCard";

export default {
	name: "FeaturesDialog",
	components: {
		Brain,
		FileText,
		Star,
		Copy,
		ChevronLeft,
		Check,
		UserX,
		BookOpen,
		Download,
		LoginCard,
	},
	props: {
		page: Number,
		showDialog: Boolean
	},
	async mounted() {
		this.setAnimation();
		const pKey = process.env.VUE_APP_STRIPE_API_PUBLIC_KEY
		this.stripe = await loadStripe(pKey);
		this.startCountdown();
	},
	data() {
		return {
			step: 0,
			selectedAnimation: this.page ? this.page - 1 : 0,
			refreshAnimation: 0,
			removeAnunci: false,
			exampleProblem: null,
			exampleProblem2: null,
			radioGroup: 1,
			url: process.env.VUE_APP_AXIOS_URI,
			apiKey: process.env.VUE_APP_STRIPE_API_KEY,
			inputCard: "",
			stripe: null,
			showDiscount: true,
			showLoginDialog: false,
			countdownText: "2 días",
			timer: null,
			booklets: [
				'Anglès',
				'Història',
				'Llengua catalana',
				'Llengua castellana',
				'Biologia',
				'Química',
				'Electrotècnia',
				'Grec',
				'Matemàtiques',
			]
		}
	},
	computed: {
		getDueDate() {
			let d = new Date();
			var year = d.getFullYear();
			var month = d.getMonth();
			var day = d.getDate();
			if (this.radioGroup === 1) d = new Date(year + 1, month, day);
			else d = new Date(year, month + 1, day);

			var dd = String(d.getDate()).padStart(2, '0');
			var mm = String(d.getMonth() + 1).padStart(2, '0'); //January is 0!
			var yyyy = d.getFullYear();

			return mm + '/' + dd + '/' + yyyy;
		},
		getPrice() {
			return this.radioGroup === 1 ? '€4.50' : '€8,99'
		},
		model: {
			get() {
				return this.showDialog
			},
			set(val) {
				this.$emit("update:showDialog", val)
			}
		}
	},
	methods: {
		closeDialog() {
			this.$emit("update:showDialog", false)
		},
		setAnimation() {
			setTimeout(() => {
				this.removeAnunci = true
			}, 2000)

			setInterval(() => {
				// this.selectedAnimation++;
				this.removeAnunci = false;
				setTimeout(() => {
					this.removeAnunci = true
				}, 2000)
			}, 7000)
		},
		async fetchProblem() {
			// Set default values for pagination
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0

			// Fetching
			const problem_id = 2531
			const path = `/problems/${problem_id}`

			// Axios
			const { data } = await this.axios.get(path)
			this.exampleProblem = data;
		},
		async fetchProblem2() {
			// Set default values for pagination
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0

			// Fetching
			const problem_id = 2489
			const path = `/problems/${problem_id}`

			// Axios
			const { data } = await this.axios.get(path)
			this.exampleProblem2 = data;
		},
		async goToStripe() {
			const user = this.$root.currentUser.value;
			const isUserLogged = user !== null;

			// User is Logged
			if (isUserLogged) {
				// Capturar premium_from de la query si existe
				const premiumFrom = this.$route.query.premium_from;

				// Guardar premium_from en la base de datos si existe
				if (premiumFrom) {
					try {
						await this.axios.post('/update-premium-from', {
							premium_from: premiumFrom
						}, {
							headers: {
								Authorization: this.$root.token.value
							}
						});
						console.log('Premium from guardado:', premiumFrom);
					} catch (error) {
						console.error('Error guardando premium_from:', error);
						// Continuar con el checkout aunque falle este paso
					}
				}

				const test = process.env.NODE_ENV === 'development';

				let price;
				let mode = "payment";

				// Plan semanal
				if (this.radioGroup === 1) {
					if (this.showDiscount) {
						price = "price_1RXjJvJQPD7NHKVkThXU8n5t"; // ID del plan semanal con descuento (€2,99)
					} else {
						price = "price_1RXjUvJQPD7NHKVkprWCznqL"; // ID del plan semanal sin descuento (€4,99)
					}
					mode = "subscription";
				}
				// Plan mensual
				else if (this.radioGroup === 2) {
					if (this.showDiscount) {
						price = "price_1RTHRcJQPD7NHKVkeBEZgicI"; // ID del plan mensual con descuento
					} else {
						price = "price_1RNKJIJQPD7NHKVki3ISLOhw"; // ID del plan mensual sin descuento
					}
					mode = "subscription";
				}

				if (price && this.stripe) {
					this.stripe.redirectToCheckout({
						successUrl: (test ? 'http://localhost:8080' : 'https://sele.ai') +
							'/premium/success?session_id={CHECKOUT_SESSION_ID}',
						cancelUrl: (test ? 'http://localhost:8080' : 'https://sele.ai') +
							'/app',
						lineItems: [
							{
								price: price,
								quantity: 1
							}
						],
						mode: mode,
						customerEmail: user.user_email,
						clientReferenceId: "cus_NiXkx5odTkuUJS"
					});
				}
			}
			// User is not logged
			else {
				// Redirigir al login o mostrar mensaje
				this.showLoginDialog = true;
			}
		},
		getRedirectUrl() {
			// Mantener el premium_from si existe en la query
			const premiumFrom = this.$route.query.premium_from;
			let redirectUrl = '/premium';

			if (premiumFrom) {
				redirectUrl += `?premium_from=${premiumFrom}`;
			}

			return redirectUrl;
		},
		startCountdown() {
			// Configurar fecha final del countdown (11 de junio de 2025)
			const endTime = new Date('2025-06-11T23:59:59');

			this.timer = setInterval(() => {
				const now = new Date();
				const timeLeft = endTime - now;

				if (timeLeft <= 0) {
					this.countdownText = "¡Oferta terminada!";
					clearInterval(this.timer);
					return;
				}

				const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
				const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

				if (days > 0) {
					this.countdownText = `${days}d ${hours}h ${minutes}m`;
				} else if (hours > 0) {
					this.countdownText = `${hours}h ${minutes}m ${seconds}s`;
				} else {
					this.countdownText = `${minutes}m ${seconds}s`;
				}
			}, 1000);
		}
	},
	watch: {
		page(val) {
			if (val > 0) {
				this.selectedAnimation = val - 1;
			}
		},
		showDialog(val) {
			// Guardar la posición de scroll actual
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

			this.$router.replace({
				query: {
					...this.$route.query,
					features_dialog: val
				}
			}).then(() => {
				// Restaurar la posición de scroll después de la navegación
				window.scrollTo(scrollLeft, scrollTop);
			}).catch(err => {
				// Ignorar errores de navegación duplicada
				if (err.name !== 'NavigationDuplicated') {
					console.error('Error actualizando URL:', err);
				}
				// Restaurar scroll incluso si hay error
				window.scrollTo(scrollLeft, scrollTop);
			});
		}
	},
	beforeDestroy() {
		if (this.timer) {
			clearInterval(this.timer);
		}
	}
}
</script>

<style scoped>
.close-icon {
	position: absolute;
	top: 16px;
	right: 16px;
	cursor: pointer;
	z-index: 1000;
}

.promo-alert {
	border-left: 5px solid #4dd453;
	animation: fade-in 0.5s ease-in-out;
}

.promo-banner {
	animation: pulse-border 2s infinite;
}

@keyframes pulse-border {
	0% {
		box-shadow: 0 0 0 0 rgba(77, 212, 83, 0.4);
	}

	70% {
		box-shadow: 0 0 0 10px rgba(77, 212, 83, 0);
	}

	100% {
		box-shadow: 0 0 0 0 rgba(77, 212, 83, 0);
	}
}

@keyframes fade-in {
	from {
		opacity: 0;
		transform: translateY(-10px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.carousel-animations>>>.v-item--active {}


@keyframes slideNotification {
	0% {
		transform: translateX(0px);
	}

	100% {
		transform: translateX(600px);
	}
}


@keyframes slideInFromTop {
	0% {
		transform: translateY(-230px);
	}

	100% {
		transform: translateY(0);
	}
}

.promo-banner code {
	background-color: rgba(77, 212, 83, 0.1);
	color: #4dd453;
	padding: 2px 6px;
	border-radius: 4px;
	font-weight: 600;
}

.problem-example-1 {
	transition-delay: 1500ms;
	animation: 0.8s ease-out 0s 1 slideInFromTop;

}

@keyframes slideInFromBottom {
	0% {
		transform: translateY(230px);
	}

	100% {
		transform: translateY(0);
	}
}


.booklet-zoom {
	transition-delay: 1500ms;
	animation: 0.8s ease-out 0s 1 centeredZoom;

}

@keyframes centeredZoom {
	0% {
		transform: scale();
	}

	100% {
		transform: translateY(0);
	}
}


.problem-example-2 {
	transition-delay: 1500ms;
	animation: 0.8s ease-out 0s 1 slideInFromBottom;
}

.problem-image>>>.v-image__image {
	image-rendering: optimizeSpeed !important;
	image-rendering: -moz-crisp-edges !important;
	;
	image-rendering: -webkit-optimize-contrast !important;
	;
	image-rendering: -o-crisp-edges !important;
	;
	image-rendering: crisp-edges !important;
	;
	-ms-interpolation-mode: nearest-neighbor !important;
	;
}

.shop-btn {
	text-transform: none !important;
	letter-spacing: 0 !important;
	font-weight: 800 !important;
	font-size: 1.05rem !important;
	border-radius: 16px !important;
	transition: filter 0.2s ease, transform 0.1s ease !important;
	border: 2px solid #4dd453 !important;
	height: 48px !important;
	padding-left: 24px !important;
	padding-right: 24px !important;
	background-color: #4dd453 !important;
	box-shadow: 0 4px 0 #42b848 !important;
	color: white;
}

.shop-btn:hover {
	filter: brightness(1.02);
	box-shadow: 0 4px 0 #58a700 !important;
	transform: translateY(0) !important;
}

.shop-btn:active {
	box-shadow: 0 0 0 #58a700 !important;
}

.shop-btn:disabled {
	opacity: 0.8;
	cursor: not-allowed;
	border: 2px solid #c9c9c9 !important;
	box-shadow: 0 4px 0 #c1c1c1 !important;
}

.anunci {
	transition-delay: 3000ms !important;
	transition-property: transform;
	-webkit-animation: slide-out-right .5s cubic-bezier(.55, .085, .68, .53) both !important;
	animation: slide-out-right .5s cubic-bezier(.55, .085, .68, .53) both !important;

}

@-webkit-keyframes slide-out-right {
	0% {
		-webkit-transform: translateY(0);
		transform: translateY(0);
		opacity: 1
	}

	100% {
		-webkit-transform: translateY(100px);
		transform: translateY(100px);
		opacity: 0
	}
}


.wrapper {
	background: linear-gradient(45deg, #F17C58, #E94584, #24AADB, #27DBB1, #FFDC18, #FF3706);
	background-size: 600% 100%;
	animation: gradient 6s linear infinite;
	animation-direction: alternate;
}

@keyframes gradient {
	0% {
		background-position: 0%
	}

	100% {
		background-position: 100%
	}
}

.tit {
	font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
	font-weight: 900 !important;
	color: #4b4b4b !important;
	letter-spacing: -0.03em !important;
}

/* Estilos para las tarjetas de planes */
.plan-cards {
	display: flex;
	width: 100%;
}

.plan-option {
	flex: 1;
	background-color: white;
	border-radius: 16px !important;
	padding: 20px;
	border: 1px solid #d6e9daab !important;
	transition: all 0.3s ease;
	cursor: pointer;
	box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08) !important;
}

.active-plan {
	background-color: #f0ffec !important;
	box-shadow: 0 16px 35px rgba(0, 0, 0, 0.12) !important;
	border: 1px solid #4dd453 !important;
}

.discount-label {
	background-color: #dbffd4;
	color: #4CAF50;
	font-size: 12px;
	font-weight: 700;
	padding: 2px 8px;
	border-radius: 50px !important;
}

.price-amount {
	font-size: 30px;
	font-weight: 700;
	color: #298e2d;
	margin-bottom: 4px;
}

.price-period {
	font-size: 16px;
	font-weight: 400;
	color: #757575;
	margin-left: 4px;
}

.price-details {
	font-size: 13px;
	color: #757575;
	margin-top: 4px;
	margin-bottom: 16px;
}

.feature-list {
	list-style-type: none;
	padding-left: 0;
}

.feature-list li span {
	color: #424242;
	line-height: 1.5;
}

.limited-offer-text {
	color: #777;
	font-style: italic;
	animation: blink 1.5s infinite alternate;
}

@keyframes blink {
	0% {
		opacity: 0.7;
	}

	100% {
		opacity: 1;
	}
}

/* Estilos específicos para móvil */
.mobile-dialog {
	margin: 0 !important;
}

.mobile-card {
	border-radius: 0 !important;
}

.mobile-layout {
	display: flex;
	flex-direction: column;
	height: 100vh;
	background-color: #fafafa;
}

.mobile-header {
	background-color: white;
	border-bottom: 1px solid #e0e0e0;
	position: relative;
}

.close-icon-mobile {
	position: absolute;
	top: 16px;
	right: 16px;
	cursor: pointer;
	z-index: 1000;
}

.mobile-features {
	background-color: white;
	margin-bottom: 8px;
}

.mobile-plans {
	background-color: white;
	margin-bottom: 8px;
}

.mobile-footer {
	background-color: white;
	margin-top: auto;
	border-top: 1px solid #e0e0e0;
}

.mobile-plan-cards {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.mobile-plan-option {
	background-color: #f8f9fa;
	border-radius: 12px !important;
	padding: 16px;
	border: 1px solid #e0e0e0 !important;
	transition: all 0.3s ease;
	cursor: pointer;
}

.mobile-plan-option.active-plan {
	background-color: #f0ffec !important;
	outline: 2px solid #4dd453 !important;
}

.discount-label-mobile {
	background-color: #dbffd4;
	color: #4CAF50;
	font-size: 10px;
	font-weight: 700;
	padding: 2px 6px;
	border-radius: 50px !important;
}

.mobile-price-amount {
	font-size: 24px;
	font-weight: 700;
	color: #298e2d;
	margin-bottom: 4px;
}

.mobile-price-period {
	font-size: 14px;
	font-weight: 400;
	color: #757575;
	margin-left: 4px;
}

.mobile-price-details {
	font-size: 12px;
	color: #757575;
	margin-top: 4px;
}

.mobile-shop-btn {
	border-radius: 12px !important;
	font-size: 14px !important;
}

/* Transición para móvil */
.dialog-bottom-transition-enter-active,
.dialog-bottom-transition-leave-active {
	transition: transform 0.3s ease-in-out;
}

.dialog-bottom-transition-enter,
.dialog-bottom-transition-leave-to {
	transform: translateY(100%);
}
</style>
